import React, {useState} from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch} from 'react-redux';
import { Divider, Loader } from 'rsuite';
import * as actionsUser  from '../../../../../app/actions/user';
import {setInstallmentText}  from '../../../../../app/common/services/vehicle.service';
import {InfoIcon} from '../../svg/iconsSvg';
import {FrameTwoIcon} from '../../svg/iconFrameTwoSvg';

const PayInstConDSuccess = ({policy, cashflowId, style}) => {

    const history = useHistory();
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);

    const cashflow = policy?.cashflows ? policy?.cashflows.find(obj => obj.cashflowId === parseInt(cashflowId) ) : {};
    let payAmount =  Number.parseFloat(cashflow?.dueAmount).toFixed(2);
    let payAmountEUR =  Number.parseFloat(cashflow?.dueAmountEUR).toFixed(2);

    const {make, model, plate} = policy?.registrationProps || {};
    const vechicleMake = make ? `${make.value} ${model?.value}` : null;
    const vechiclePlate = plate ? ` ${plate?.value}` : null;

    const insCompany = policy?.insCompany;
    const registered = policy?.questions?.generalRegistrationType === '1' ? true : false;

    const infoTexts = ['Успешно завърши поръчка на полица с наложен платеж', 'Твоята полица е в процес на обработка', 'Ще получиш имейл когато полицата е готова',
                    insCompany === 'dallbogg' && !registered
                    ? 'При склюване на 1-годишна полица за нерегистрирано МПС е необходимо в 30 дневен срок да ни изпратиш талона на автомобила на help@nuins.io, за да не бъде прекратена полицата'
                    : null
                    ];

    const goToMyPolicy = async () => {

        setLoading(true);
        await dispatch(actionsUser.getMyPolicies());

        history.push("/app/my-policies");

    }

    const renderInfoTexts = () => {
        return infoTexts.filter(text => text).map((text, i) => {
                return <div className="steps_container-info" key={i+1}>
                            <div>
                                <InfoIcon size="20" style={{marginLeft: '2px'}}/>
                            </div>
                            <div>{text}</div>
                        </div>
        })
    }

    return (
        <div className="steps_container" style={style}>
            <div  className="head">
                <h6 className="title" style={{marginRight: '48px'}}>{setInstallmentText(cashflow)}</h6>
            </div>
            <Divider style={{marginBottom: 0 , backgroundColor: '#6bdfa7', height: '1px'}}/>
            <div className="payment-card">
                <div className="left">
                    <p style={{marginBottom: '8px'}}>{vechicleMake}</p>
                    <p style={{}}>{vechiclePlate}</p>
                </div>
                <div className="right">
                <p style={{marginBottom: '8px', opacity: '.7'}}>Платена сума</p>
                <p style={{fontWeight: '700', fontSize: '15px', paddingLeft: '8px'}}>{payAmountEUR} € / {payAmount} лв.</p>
                </div>
            </div>
            <div className="big-icon-container" style={{margin: '20px 0'}}>
                <FrameTwoIcon size={120}/>
            </div>
            {renderInfoTexts()}
    
            <button className="nuIns-btn nuIns-btn-main" style={{margin: '36px 0'}} onClick={goToMyPolicy}>Моите полици</button>           
            
            {loading ? <Loader backdrop center size="lg" speed="slow" /> : null}           
            
        </div>
    )
}

export default PayInstConDSuccess;